<template>
  <div id="app">
    <NavTools />
    <Alert />
    <Spinner />
    <div id="nav" v-if="!$route.name">
      Loading...
    </div>
    <div id="nav" v-if="$route.name && $route.name.startsWith('iver') && $route.name != 'iver-interview-room'">
      <router-link :to="{ name: 'iver-interview-list' }">My Interviews</router-link>      
      <router-link :to="{ name: 'iver-script-list' }">My Scripts</router-link>
      <router-link :to="{ name: 'iver-all-scripts' }">All Scripts</router-link>
      <router-link :to="{ name: 'iver-interview-feedback-list' }">My Interview Feedback</router-link>
      <router-link :to="{ name: 'iver-script-feedback-list' }">My Script Feedback</router-link>
      <router-link :to="{ name: 'iver-resources' }">Resources</router-link>
    </div>
    <div id="nav" v-if="$route.name && $route.name.startsWith('qa')">
      <router-link :to="{ name: 'qa-master-list' }">QA</router-link>
      <router-link :to="{ name: 'qa-past-due-list' }">Past Due</router-link>
      <router-link :to="{ name: 'qa-stuck-interview-list' }">Stuck Interviews, etc.</router-link>
      <router-link :to="{ name: 'qa-review-list' }">Review</router-link>
      <router-link :to="{ name: 'qa-staff-assist-list' }">Staff Assist</router-link>
      <router-link :to="{ name: 'qa-ws-invalid' }">Invalid</router-link>
    </div>
    <router-view />
    <nav class="navbar navbar-default  navbar-bottom navbar-fixed-bottom" role="navigation">
        <div class="container text-center">
            <p class="navbar-text col-md-12 col-sm-12 col-xs-12">&copy; InitialView {{ currentYear }}</p>
        </div>
    </nav>
  </div>
</template>

<script>
import jQuery from "jquery";
const $ = (window.$ = window.jQuery = jQuery);

import Alert from "../../components/Alert.vue";
import Spinner from "../../components/Spinner.vue";
import NavTools from "@/components/NavTools.vue";

export default {
  beforeMount() {
    // this.checkEnv();
    window.jQuery = $;
    window.$ = $;
    require("bootstrap");
  },
  components: {
    Alert,
    Spinner,
    NavTools
  },
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
};
</script>

<style lang="scss">

h4 {
  font-size:18px;
}

$orange: #e96724;
$turquoise: #79a9ad;
$darkturquoise: #2a606e;
$lightturquoise: #f1fafb;
$darkplum: #6a605f;
$lightgrey: #e5e5e5;
$medgrey: #cbcbcb;

.orangeFont {
  color: $orange;
}


.greyFont {
  color: #ADADAD;
}

.debug-bubble {
  border: 2px solid $turquoise;
  border-radius: 35px;
  padding: 3px 9px 5px 9px;
}

.iver-form-grey {
  background-color: $lightgrey;
  border-radius: 5px;
  padding: 3px 10px 10px 10px;
}

#app {
  font-family: "Lato";
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;*/
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: $turquoise;
  padding: 10px;
}

#nav a.router-link-exact-active {
  color: $orange;
}

.script-line del {
  margin-top: -1px;
  text-decoration: none;
  background-color: #ffb6ba;
  border-radius: 0.2em;
}

.script-line ins {
  margin-top: -1px;
  text-decoration: none;
  background-color: #97f295;
  border-radius: 0.2em;
  text-align: left;
}

.validation-message {
  color: $orange;
  font-size: 12px;
}

// ------ Toggles
.toggle-area {
  /* background-color: rgb(254,239,234); */
  background-color: white;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgb(181, 181, 181);
  border: solid 1px rgb(181, 181, 181);
  padding: 9px 12px;
  margin-left: -8px;
  margin-right: -8px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #dd5225;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: rgb(121, 169, 172);
}

input:focus + .slider {
  box-shadow: 0 0 1px rgb(121, 169, 172);
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
/* CSS FOR All 2016 Templates */

/* bootstrap mods */

body {
	background-color: #E9ECEF;
	padding-top:69px;
	padding-bottom:50px;
}

a {
	color:#e96724;
}

.row {
	margin-top:15px;
	margin-bottom:15px;
}

.btn {
    background-image: none;
}

[v-cloak] { 
    display: none 
}

.disabled {
	pointer-events: none;
}

/* messages */

.messagebox {
	position: fixed;
	top:0px;
    height:0px;
	width:100%;
	margin:auto;
	display:block;
	float:right;
	text-align:center;
	z-index:2000;  /* navbar is 1030 */
}

/* loading */

.loading {
	position:fixed;
	top:200px;
	width:100%;
	margin:auto;
	text-align:center;
	z-index:2000;
}

.loading img{
	width:40px;
}

.navbar-brand {
	padding:0 !important;
	padding-left:10px !important;
    height:69px;
}

.navbar-nav {
  padding-top:10px;
}

/* .navbar-bottom {
	background: inherit;
} */

/* ios disable zooming on text fields */
@media screen and (-webkit-min-device-pixel-ratio:0) { 
  select:focus,
  textarea:focus,
  input:focus {
    font-size: 14px;
    background: #efefef;
  }
}

@media screen and (-webkit-min-device-pixel-ratio:0) { 
  select,
  textarea,
  input {
    font-size: 14px;
  }
}

/* decorations */

.highlight {
	background-color: #E8F1FE;
	/* options:
	 E96724
	 F46E17
	 F57D2E
	 F68B46
	 F79A5D
	 F8A874
	 FAB78B
	 FBC5A2
	 FCD4B9
	 FDE2D1
	 FEF1E8
	 FFFFFF
	 */
}

.hovergray:hover {
	background-color: #D8E1E9;
    /* background-color: #efefef; */
}

.hovergray:active {
    background-color: #C8D1DE;
}

.orangeFont {
	color:#e96724;
}

.orangeNote {
	color:#e96724;
	font-size: 8pt;
}

.orangeBackground {
	background-image: none;
	background-color:#e96724;
}

.btn-orange {
	background-image: none;
	background-color:#e96724;
	color:white;
}

.text-orange {
	color:#e96724;
}

.notice {
    background-color: #e96724;
    color:white;
    padding:10px 0px 10px 15px;
}

.bookingHeader {
    color:#e96724;
}

.accountFormHeaderBlue {
    background-color: #79a9ad;
    color: white;
    padding:17px 0px 17px 15px ;
}

hr {
    border-top: 1px lightgray solid;
}


/*utils*/
.wrap { 
   white-space: pre-wrap;      /* CSS3 */   
   white-space: -moz-pre-wrap; /* Firefox */    
   white-space: -pre-wrap;     /* Opera <7 */   
   white-space: -o-pre-wrap;   /* Opera 7 */    
   word-wrap: break-word;      /* IE */
}

.modal-content {
	overflow-y: scroll;
}

.alert-fixed {
    position:fixed; 
    top: 10px; 
    right: 10px; 
    width: 30%;
    z-index:9999; 
    border-radius:0px
}

.fade-enter-active {
  transition: opacity .4s
}

.fade-enter {
    opacity: 0;
}

.fade-enter-to {
	opacity: 1;
}
/* latin */
@font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: local('Lato Regular'), local('Lato-Regular'),
      url(../../assets/fonts/Lato-Regular.woff2) format('woff2'),
      url(../../assets/fonts/Lato-Regular.woff) format('woff'),
      url(../../assets/fonts/Lato-Regular.ttf) format('truetype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
  }
  
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    src: local('Lato Bold'), local('Lato-Bold'), url(../../assets/fonts/Lato-Bold.ttf) format('truetype');
  }
  
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    src: local('Lato Black'), local('Lato-Black'), url(../../assets/fonts/Lato-Black.ttf) format('truetype');
  }
  
  @font-face {
    font-family: 'BlackGate';
    font-style: normal;
    font-weight: 400;
    src: url(../../assets/fonts/BlackGate-Sans.otf) format('opentype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
  }
  
  @font-face {
    font-family: 'Honeymoon';
    font-style: normal;
    font-weight: 400;
    src: url(../../assets/fonts/Honeymoon.ttf) format('truetype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
  }
  
  body {
    font-family: 'Lato', Helvetica, sans-serif !important;
  }

  /* style for calendar */

    .clndr-grid {
        padding-top:10px;
    }
    .days {
        padding-top:7px;
    }
    
    .day-selected {
        background: #4F7ABA;
    }
    
    .day-number {
        position-top:0px;
        line-height:37px;
    }

    #booking-clndr .clndr-grid .days .day > div {
        width: calc(100% + 20px);
        height: calc(100% + 20px);
        position: relative;
        left: -10px;
        top: -10px;
    }
    #booking-clndr .clndr-grid .days .day:hover > div {
        box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.4);
    }
    #booking-clndr > div > div.clndr-left > div.clndr-grid > div.days > div > div > span {
        left: 14px;
        top: 0px;
        font-size: 10pt;
        color: #9b9b9a;
        z-index: 1;
        position: absolute;
        cursor: default !important;
    }
    #booking-clndr .clndr-grid .days .day:after {
        content: "";
        display: block;
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0px;
        bottom: 0px;
        box-sizing: border-box;

        background-image: url('/s/img/booking/gray-trig.png');
    }

    #booking-clndr .clndr-grid .days .day.sunday:after, .adjacent-month:after {
        background-image: none !important;
    }
    #booking-clndr .clndr-grid .days .day.plenty-slots:after {
        background-image: url('/s/img/booking/plenty.png');
    }
    #booking-clndr .clndr-grid .days .day.few-slots:after {
        background-image: url('/s/img/booking/few.png');
    }



    /* a {
        color: #4F68ef;
    }
    */

    .control-label {
        font-weight: normal;
    }

    .fieldTitle {
        color: #e96724;
        padding-bottom: 20px;
        font-size:12pt;
    }

    .fieldValue {
        font-size:12pt;
    }

    .btn-orange {
        background-color: #e96724 !important;        
        color:white !important;
        text-shadow: none;
        border: 1px solid darkgray;
    }
    .btn-orange:hover {
        background-color: #de5800 !important;        
        color:white !important;
        text-shadow: none;
    }

    .btn-danger {
        background-color: #d9534f !important;        
        color:white !important;
        text-shadow: none;
        border: 1px solid darkgray;
    }
    .btn-danger:hover {
        background-color: #d9534f !important;        
        color:white !important;
        text-shadow: none;
    }

    .btn-warning {
        background-color: #f0ad4e !important;        
        color:white !important;
        text-shadow: none;
        border: 1px solid darkgray;
    }
    .btn-warning:hover {
        background-color: #f0ad4e !important;
        color:white !important;
        text-shadow: none;
    }

    .btn-default {
        background-color: #fff !important;
        color:#333;
        text-shadow: none;
        border: 1px solid darkgray;
    }
    .btn-default:hover {
        background-color: #eee !important;
        color:#222;
        text-shadow: none;
    }

    .checkbox-inline {
        color: #5D7294;
    }

    .time-view-note {
        font: italic 15px 'Lato', sans-serif;margin: 0px 40px 20px !important;text-align: center;
    }

    .availableTimesBox {
        /* border: 3px solid #79a9ad; */
    }

    .availableTimesTitle {
        font-size:18pt;
        color:#2a606e;
        /* background-color:white; */
        background-image:none;
    }

    .timeZoneTitle {
        color:#2a606e;
        /* color: white; */
        /* background-color: #79a9ad; */
        background-image:none;
    }

    div#accordion.timezone .panel-title {
        line-height: 1.5;
    }

    div#accordion.timezone .panel {
        border: 0;
    }

    .timezone-heading {
        border-style: solid;
        border-top-width: 5px;
        border-top-color: #e96724;
        border-radius:0px;
        color: #FFFFFF;
        background-color: #e96724;
        border-left: 0px;
        border-right: 0px;
        width: 100%;
        text-align: left;
    }

    .timezone-heading.collapsed  {
        background-color: #FFFFFF;
        color: #686868;
    }

    /***********  CSS shapes  ***********/

    .timezone-heading.collapsed .arrow {
        width: 0; 
        height: 0; 
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
          
        border-top: 13px solid #e96724;
        padding-top:1px;
        margin-top: 5px;
    }

    .timezone-heading .arrow {
        width: 0; 
        height: 0; 
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
      
        border-bottom: 13px solid #FFFFFF;
        padding-top:1px;
        margin-top: 5px;
    }


    .arrow-down {
        width: 0; 
        height: 0; 
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
          
        border-top: 13px solid #e96724;
        padding-top:1px;
        margin-top: 5px;
    }

    .arrow-up {
        width: 0; 
        height: 0; 
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
      
        border-bottom: 13px solid #FFFFFF;
        padding-top:1px;
    }

    .circle {
        border-radius: 50%;
        width: 22px;
        height: 22px; 
        border: 2px solid #686868;
        color:#e96724;
    }

    .wrapper {
        position: relative;
    }

    .wrapper .glyphicon {
        position: absolute;
        top:4px;
        left: 4px;
        color: #e96724;
    }    
//clndr css
.bg-gray {
  background-color: #414141;
}
.bg-red {
  background-color: #ff5a45;
}
.bg-red a {
  color: #ff5a45;
}
.bg-red a:hover {
  background-color: #ffb4ab;
  color: #212121;
}
.bg-blue {
  background-color: #71bbd2;
}
.bg-green {
  background-color: #97ce7f;
}
.bg-yellow {
  background-color: #ddca9a;
}
.center {
  text-align: center;
}
.header {
  padding: 30px 0;
}
.more-space {
  margin-top: 3em;
}
.noselect {
  -webkit-user-select: none;
  /* Chrome/Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
}
#booking-clndr .clndr {
  overflow: hidden;
  /* border-bottom: 7px solid #69a776; */
}
#booking-clndr .clndr .clndr-controls {
  background-color: #69a776;
  color: white;
}
#booking-clndr .clndr .clndr-controls .clndr-previous-button,
#booking-clndr .clndr .clndr-controls .clndr-next-button {
  width: 15%;
  padding-top: 5px;
  padding-bottom: 5px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  /* Chrome/Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
  -webkit-transition: background-color 0.5s;
  -moz-transition: background-color 0.5s;
  -ms-transition: background-color 0.5s;
  -o-transition: background-color 0.5s;
  transition: background-color 0.5s;
}
#booking-clndr .clndr .clndr-controls .clndr-previous-button:hover,
#booking-clndr .clndr .clndr-controls .clndr-next-button:hover {
  /* background-color: #528b5e; */
}
#booking-clndr .clndr .clndr-controls .month {
  width: 70%;
  padding-top: 5px;
  padding-bottom: 5px;
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
}
#booking-clndr .clndr .days-container {
  position: relative;
  /* width: 707px; */
  height: 500px;
  display: inline-block;
}
#booking-clndr .clndr .days-container .days {
  position: absolute;
  left: 0;
  /* width: 707px; */
  height: 500px;
  -webkit-transition: left 0.5s;
  -moz-transition: left 0.5s;
  -ms-transition: left 0.5s;
  -o-transition: left 0.5s;
  transition: left 0.5s;
  background-color: #ebebeb;
}
#booking-clndr .clndr .days-container .days .day,
#booking-clndr .clndr .days-container .days .empty {
  width: 100px;
  display: inline-block;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  text-align: center;
  color: #212121;
  border-right: 1px solid rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
#booking-clndr .clndr .days-container .days .day.event,
#booking-clndr .clndr .days-container .days .empty.event {
  background-color: #d2d2d2;
  -webkit-transition: background-color 0.5s;
  -moz-transition: background-color 0.5s;
  -ms-transition: background-color 0.5s;
  -o-transition: background-color 0.5s;
  transition: background-color 0.5s;
  cursor: pointer;
}
#booking-clndr .clndr .days-container .days .day.event:hover,
#booking-clndr .clndr .days-container .days .empty.event:hover {
  background-color: #b8b8b8;
}
#booking-clndr .clndr .days-container .days .day.adjacent-month,
#booking-clndr .clndr .days-container .days .empty.adjacent-month {
  color: rgba(0, 0, 0, 0.3);
}
#booking-clndr .clndr .days-container .days .empty {
  height: 83.33333333px;
  vertical-align: bottom;
}
#booking-clndr .clndr .days-container .days .headers {
  background-color: #97ce7f;
  padding-top: 5px;
  padding-bottom: 5px;
}
#booking-clndr .clndr .days-container .days .headers .day-header {
  width: 100px;
  display: inline-block;
  text-align: center;
  color: white;
}
#booking-clndr .clndr .days-container .events {
  position: absolute;
  left: 707px;
  /* width: 707px; */
  height: 500px;
  -webkit-transition: left 0.5s;
  -moz-transition: left 0.5s;
  -ms-transition: left 0.5s;
  -o-transition: left 0.5s;
  transition: left 0.5s;
  background-color: #ebebeb;
}
#booking-clndr .clndr .days-container .events .headers {
  position: relative;
}
#booking-clndr .clndr .days-container .events .event-header {
  width: 100%;
  background-color: #97ce7f;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
  color: white;
}
#booking-clndr .clndr .days-container .events .x-button {
  position: absolute;
  font-size: 80%;
  top: 7px;
  left: 20px;
  cursor: pointer;
  -webkit-transition: color 0.25s;
  -moz-transition: color 0.25s;
  -ms-transition: color 0.25s;
  -o-transition: color 0.25s;
  transition: color 0.25s;
}
#booking-clndr .clndr .days-container .events .x-button:hover {
  color: white;
}
#booking-clndr .clndr .days-container .events .events-list {
  overflow: scroll;
  height: 185px;
}
#booking-clndr .clndr .days-container .events .events-list .event {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  -webkit-transition: background-color 0.25s;
  -moz-transition: background-color 0.25s;
  -ms-transition: background-color 0.25s;
  -o-transition: background-color 0.25s;
  transition: background-color 0.25s;
}
#booking-clndr .clndr .days-container .events .events-list .event:hover {
  background-color: #f5f5f5;
}
#booking-clndr .clndr .days-container .events .events-list .event a {
  position: relative;
  font-size: 12px;
  letter-spacing: 1px;
  background-color: transparent;
  color: #212121;
  text-decoration: none;
  -webkit-transition: color 0.25s;
  -moz-transition: color 0.25s;
  -ms-transition: color 0.25s;
  -o-transition: color 0.25s;
  transition: color 0.25s;
}
#booking-clndr .clndr .days-container .events .events-list .event a:hover {
  background-color: transparent;
  color: #69a776;
}
#booking-clndr .clndr .days-container.show-events .days {
  left: -707px;
}
#booking-clndr .clndr .days-container.show-events .events {
  left: 0;
}
span.code {
  padding: 0 2px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
}
.block {
  padding: 80px 0;
  width: 100%;
}
.inner {
  max-width: 960px;
  padding: 0 20px;
  margin: 0 auto;
}
.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}
.clearfix {
  display: inline-block;
}
html[xmlns] .clearfix {
  display: block;
}
* html .clearfix {
  height: 1%;
}
strong {
  font-weight: 700;
}
@media all and (max-width: 768px) {
  #booking-clndr .clndr-grid {
    width: 100%;
    border: none;
  }
  #booking-clndr .event-listing {
    display: none;
  }
}

// ------ end toggles
</style>
